type TabKey = "overview" | "schedule" | "performance" | "shifts" | "files";

type Tab = {
  key: TabKey;
  label: string;
  icon: string;
  badge?: string;
};

const TABS: Tab[] = [
  { key: "overview", label: "Overview", icon: "ri-dashboard-2-line" },
  { key: "schedule", label: "Schedule", icon: "ri-calendar-2-line" },
  { key: "performance", label: "Performance", icon: "ri-line-chart-line" },
  { key: "shifts", label: "Shifts", icon: "ri-time-line" },
  { key: "files", label: "Documents", icon: "ri-folder-3-line" },
];

type Props = {
  active: TabKey;
  onChange: (k: TabKey) => void;
};

export default function WorkTabs({ active, onChange }: Props) {
  return (
    <div className="bg-white border border-ink-100 rounded-lg p-1 flex items-center gap-1 overflow-x-auto scrollbar-thin">
      {TABS.map((t) => {
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className={`relative flex items-center gap-2 px-3.5 py-2 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-all ${
              isActive
                ? "bg-ink-900 text-white shadow-sm"
                : "text-ink-600 hover:bg-cream-100"
            }`}
          >
            <i className={`${t.icon} text-base`}></i>
            <span>{t.label}</span>
            {t.badge && (
              <span
                className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                  isActive ? "bg-white/20 text-white" : "bg-brand-100 text-brand-700"
                }`}
              >
                {t.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export type { TabKey };